import moment from 'moment'

export default class Common {

    static eventBus = new EventBus();

    static convertFromUnixTimeToDDMMYYYY(unix) {
        if (!unix) {
            return "";
        }
        return moment.unix(parseInt(unix) / 1000).format('DD-MM-YYYY');
    }

    static validateEmail(value) {
        return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value));
    }

    static randomString() {
        return Math.random().toString(36).substring(2, 15);
    }

    static error(textValue) {
        Swal.fire({
            icon: 'error',
            title: 'Błąd',
            text: textValue
        });
    }

    static generalError() {
        Swal.fire({
            icon: 'error',
            title: 'Błąd',
            text: 'Spróbuj później'
        });
    }

    static validateToken(token) {
        if (token.trim().length < 8) {
            return 'Proszę podać 8 znaków';
        } else {
            return null;
        }
    }

    static validatePhone(phone) {
        if (phone.trim().length < 9) {
            return 'Proszę podać 9 cyfr';
        } else {
            return null;
        }
    }

    static searchClients(phrase) {
        return fetch(Common.BASE_API + 'report/client/' + phrase).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getClients() {
        return fetch(Common.BASE_API + 'report/clients').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getLoginCode(phone) {
        let validationError = Common.validatePhone(phone);
        if (validationError) {
            return Promise.reject(validationError);
        }
        return fetch(Common.BASE_API + 'report/' + phone.substr(0, 9)).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getLoginToken(phoneVal, codeVal) {

        let validationError = Common.validatePhone(phoneVal);
        if (validationError) {
            return Promise.reject(validationError);
        }

        validationError = Common.validatePhone(phoneVal);
        if (validationError) {
            return Promise.reject(validationError);
        }

        return fetch(Common.BASE_API + 'report', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                phone: phoneVal,
                code: codeVal
            })
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getStats() {
        return fetch(Common.BASE_API + 'report').then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static isValidPesel(pesel) {
        if (typeof pesel !== 'string')
            return false;

        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
        let sum = 0;
        let controlNumber = parseInt(pesel.substring(10, 11));
        for (let i = 0; i < weight.length; i++) {
            sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
        }
        sum = sum % 10;
        return (10 - sum) % 10 === controlNumber;
    }

    static getNetto(amount, taxType) {
        if (taxType === 'NETTO') {
            return amount;
        }
        if (taxType === 'BRUTTO') {
            return (amount * 100 / 123).toFixed(0);
        }
        return (amount * 100 / 81).toFixed(0);
    }
};

//Common.BASE_API = 'http://localhost:8080/api/';

Common.BASE_API = 'https://app.busbrat.pl/api/';
